import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';

interface GetLinkResponse {
  status: string;
  message?: string;
  link: string;
}

export async function getDecryptedLink(
  link: string,
): Promise<GetLinkResponse | null> {
  try {
    const response = await apiClient.post<GetLinkResponse>('get-link', {link});
    return response?.data;
  } catch (error) {
    showHttpErrorToast(error)
    return null
  }
}
